// Workflow JSON Codec — compress for export, decompress on import.
// Strips default / null / empty values and uses short keys to reduce payload size.

var SHORT_NODE_KEYS = {
  id: 'i', kind: 'k', nodeType: 'nt', category: 'ca', title: 't',
  subtitle: 'st', icon: 'ic', logoUrl: 'lu', templateId: 'ti',
  code: 'co', generationPrompt: 'gp', changeHistory: 'ch', inputDescription: 'id',
  agentDescription: 'ad', inputExample: 'ie', outputDescription: 'od',
  label: 'l', borderColor: 'bc', options: 'op', stats: 'ss',
  hyperparameters: 'hp', conditionRule: 'cr', size: 'sz',
  paramValues: 'pv', position: 'po'
};

var SHORT_CONN_KEYS = {
  id: 'i', from: 'f', to: 't', fromAnchor: 'fa', toAnchor: 'ta',
  propPath: 'pp', noWait: 'nw', noData: 'nd', branch: 'br'
};

var LONG_NODE_KEYS = invert(SHORT_NODE_KEYS);
var LONG_CONN_KEYS = invert(SHORT_CONN_KEYS);

var DEFAULT_CONDITION_RULE = {
  mode: 'simple',
  logic: 'and',
  conditions: [{ type: 'condition', id: 'cond-default', operator: 'equals', value: '' }],
  root: {
    type: 'group', id: 'group-default', logic: 'and',
    items: [{ type: 'condition', id: 'cond-default', operator: 'equals', value: '' }]
  }
};

function invert(obj) {
  var out = {};
  var keys = Object.keys(obj);
  for (var idx = 0; idx < keys.length; idx++) {
    out[obj[keys[idx]]] = keys[idx];
  }
  return out;
}

function isDefaultConditionRule(cr) {
  if (!cr || typeof cr !== 'object') return false;
  if (cr.mode !== 'simple' || cr.logic !== 'and') return false;
  var c = cr.conditions;
  if (!Array.isArray(c) || c.length !== 1) return false;
  var c0 = c[0];
  if (!c0 || c0.type !== 'condition' || c0.id !== 'cond-default' || c0.operator !== 'equals' || c0.value !== '') return false;
  var r = cr.root;
  if (!r || r.type !== 'group' || r.id !== 'group-default' || r.logic !== 'and') return false;
  var ri = r.items;
  if (!Array.isArray(ri) || ri.length !== 1) return false;
  var ri0 = ri[0];
  return ri0 && ri0.type === 'condition' && ri0.id === 'cond-default' && ri0.operator === 'equals' && ri0.value === '';
}

function isEmpty(val) {
  if (val === null || val === undefined) return true;
  if (val === '') return true;
  if (Array.isArray(val) && val.length === 0) return true;
  return false;
}

function remapKeys(obj, keyMap) {
  if (!obj || typeof obj !== 'object') return obj;
  var out = {};
  var keys = Object.keys(obj);
  for (var idx = 0; idx < keys.length; idx++) {
    var k = keys[idx];
    out[keyMap[k] || k] = obj[k];
  }
  return out;
}

// --- Compress ---

function compressNode(node) {
  if (!node || typeof node !== 'object') return node;
  var out = {};
  var keys = Object.keys(node);
  for (var idx = 0; idx < keys.length; idx++) {
    var k = keys[idx];
    var v = node[k];

    // Skip default values
    if (k === 'kind' && v === 'workflow-node') continue;
    if (k === 'conditionRule' && isDefaultConditionRule(v)) continue;
    if (k === 'changeHistory' && Array.isArray(v) && v.length === 0) continue;
    if (isEmpty(v)) continue;

    var shortKey = SHORT_NODE_KEYS[k] || k;
    out[shortKey] = v;
  }
  return out;
}

function compressConnection(conn) {
  if (!conn || typeof conn !== 'object') return conn;
  var out = {};
  var keys = Object.keys(conn);
  for (var idx = 0; idx < keys.length; idx++) {
    var k = keys[idx];
    var v = conn[k];

    // Skip default values for connections
    if (k === 'noWait' && v === false) continue;
    if (k === 'noData' && v === false) continue;
    if (isEmpty(v)) continue;

    var shortKey = SHORT_CONN_KEYS[k] || k;
    out[shortKey] = v;
  }
  return out;
}

function compressWorkflow(state) {
  if (!state || typeof state !== 'object') return state;
  var compressed = { _v: 1 };
  if (state.workflowName) compressed.wn = state.workflowName;
  if (state.aiInstruction) compressed.ai = state.aiInstruction;
  if (Array.isArray(state.nodes) && state.nodes.length > 0) {
    compressed.n = state.nodes.map(compressNode);
  }
  if (Array.isArray(state.connections) && state.connections.length > 0) {
    compressed.c = state.connections.map(compressConnection);
  }
  if (Array.isArray(state.groups) && state.groups.length > 0) {
    compressed.g = state.groups;
  }
  return compressed;
}

// --- Decompress ---

function decompressNode(node) {
  if (!node || typeof node !== 'object') return node;
  var full = remapKeys(node, LONG_NODE_KEYS);

  // Restore defaults
  if (full.kind === undefined) full.kind = 'workflow-node';
  if (full.logoUrl === undefined) full.logoUrl = null;
  if (full.code === undefined) full.code = '';
  if (full.generationPrompt === undefined) full.generationPrompt = '';
  if (full.changeHistory === undefined) full.changeHistory = [];
  if (full.borderColor === undefined) full.borderColor = '';
  if (full.options === undefined) full.options = null;
  if (full.stats === undefined) full.stats = null;
  if (full.hyperparameters === undefined) full.hyperparameters = null;
  if (full.size === undefined) full.size = null;
  if (full.paramValues === undefined) full.paramValues = {};
  if (full.conditionRule === undefined) {
    full.conditionRule = JSON.parse(JSON.stringify(DEFAULT_CONDITION_RULE));
  }
  if (full.position === undefined) full.position = { left: 0, top: 0 };

  return full;
}

function decompressConnection(conn) {
  if (!conn || typeof conn !== 'object') return conn;
  var full = remapKeys(conn, LONG_CONN_KEYS);

  if (full.noWait === undefined) full.noWait = false;
  if (full.noData === undefined) full.noData = false;

  return full;
}

function decompressWorkflow(data) {
  if (!data || typeof data !== 'object') return data;

  // If it's not a compressed format (no _v flag), return as-is
  if (!data._v) return data;

  return {
    workflowName: data.wn || '',
    aiInstruction: data.ai || '',
    nodes: Array.isArray(data.n) ? data.n.map(decompressNode) : [],
    connections: Array.isArray(data.c) ? data.c.map(decompressConnection) : [],
    groups: Array.isArray(data.g) ? data.g : []
  };
}

// --- Planner compressed format ---
// The planner outputs a lightweight JSON with short keys to save AI tokens.
// Planner node short keys (different from export — planner nodes use "type" not full node fields):
var SHORT_PLANNER_NODE_KEYS = {
  id: 'i', type: 'ty', title: 't', icon: 'ic', generationPrompt: 'gp',
  hyperparameters: 'hp', paramValues: 'pv', position: 'po',
  conditionRule: 'cr', templateId: 'ti', code: 'co', logoUrl: 'lu',
  size: 'sz'
};
var SHORT_PLANNER_CONN_KEYS = {
  from: 'f', to: 't', fromAnchor: 'fa', toAnchor: 'ta',
  propPath: 'pp', noWait: 'nw', noData: 'nd', branch: 'br'
};
var LONG_PLANNER_NODE_KEYS = invert(SHORT_PLANNER_NODE_KEYS);
var LONG_PLANNER_CONN_KEYS = invert(SHORT_PLANNER_CONN_KEYS);

function decompressPlannerNode(node) {
  if (!node || typeof node !== 'object') return node;
  var full = remapKeys(node, LONG_PLANNER_NODE_KEYS);
  // Restore planner defaults
  if (full.type === undefined) full.type = 'custom';
  if (full.paramValues === undefined) full.paramValues = {};
  if (full.position === undefined) full.position = { left: 0, top: 0 };
  return full;
}

function decompressPlannerConnection(conn) {
  if (!conn || typeof conn !== 'object') return conn;
  var full = remapKeys(conn, LONG_PLANNER_CONN_KEYS);
  if (full.fromAnchor === undefined) full.fromAnchor = 'right';
  if (full.toAnchor === undefined) full.toAnchor = 'left';
  if (full.noWait === undefined) full.noWait = false;
  if (full.noData === undefined) full.noData = false;
  return full;
}

function decompressPlannerWorkflow(data) {
  if (!data || typeof data !== 'object') return data;
  return {
    workflowName: data.wn || data.workflowName || '',
    nodes: Array.isArray(data.n || data.nodes)
      ? (data.n || data.nodes).map(decompressPlannerNode)
      : [],
    connections: Array.isArray(data.c || data.connections)
      ? (data.c || data.connections).map(decompressPlannerConnection)
      : [],
    groups: Array.isArray(data.g || data.groups) ? (data.g || data.groups) : []
  };
}

function isCompressedPlannerWorkflow(data) {
  return data && typeof data === 'object' && (data.n || data.c || data.wn);
}

// --- Public API ---

function isCompressedWorkflow(data) {
  return data && typeof data === 'object' && data._v === 1;
}

// Pure short-key → long-key remaps WITHOUT default restoration. Used by the
// Workflow Copilot edit applier to expand partial `set` payloads (a full
// decompressNode would clobber untouched fields with defaults).
function expandNodeKeys(obj) {
  return remapKeys(obj, LONG_NODE_KEYS);
}

function expandConnKeys(obj) {
  return remapKeys(obj, LONG_CONN_KEYS);
}

module.exports = {
  compressWorkflow: compressWorkflow,
  decompressWorkflow: decompressWorkflow,
  isCompressedWorkflow: isCompressedWorkflow,
  decompressPlannerWorkflow: decompressPlannerWorkflow,
  isCompressedPlannerWorkflow: isCompressedPlannerWorkflow,
  expandNodeKeys: expandNodeKeys,
  expandConnKeys: expandConnKeys
};
